import React, {Component} from 'react';
import Utils from './Utils';
/**
 * Stav Eventu, tedy kolik je přihlášených na danou bohoslužbu
 */
export default class EventState extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mySum: null,            
        }        
    }

// Iniciální načtení dat
    // getCount vrátí počet přihlášených
    componentDidMount() {
      this.getCount(); //Poprvé hned aby se nečekalo v count
      this.interval = setInterval(() => this.getCount(), 10000); //5sec.
      }
    
      componentWillUnmount() {
        clearInterval(this.interval);
      }

    
    getCount(){
        var formData = new FormData();
        formData.append('countReservations', true);
        formData.append('EventId', this.props.myEventId);
        
        let fetchData = { 
          method: 'POST', body: formData,      
          headers: {
             headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          },  
        }
  
      // A posílám
      fetch(Utils.getURL(), fetchData)   
      .then(response => response.json())
      .then(data => {   
          
          if ( data["success"]) {
          // console.log('Počet:',  data["count"]);
            this.setState({mySum: this.props.myMax - data["count"] }) // Po přihlášení na hlavní stránku
            
          }
            else{
                    console.log('Neúspěch:', data["message"]);
                    this.setState({mySum : 0 })    
              }
      })
      .catch((error) => {
        console.error('Chyba:', error);
                          
      });  
    } // konec getCount

/**
 * vrátí naformátovaná volná místa
 * 
 */ getRenderSum(){
let myFree = 0;

myFree = this.state.mySum;
if (this.state.mySum == null) { // Toto je jen pro načtení na začátku
  return <div><table><tr><td class="sum-1" > </td><td>volných míst</td></tr></table></div>
}
   else if (myFree < 1 ) {
      return <div><table><tr><td class="sum-0" >0</td><td>volných míst</td></tr></table></div>
    }
    else if (myFree === 1) {
      return <div><table><tr><td class="sum-1" >{myFree}</td><td>volné místo</td></tr></table></div>
    }
    else if (myFree > 1 && myFree < 5) {
      return <div><table><tr><td class="sum-1" >{myFree}</td><td>volná místa</td></tr></table></div>
    }
    else{
      return <div><table><tr><td class="sum-1" >{myFree}</td><td>volných míst</td></tr></table></div>
    }
}

        render() {
        return (
            <div >
              {this.getRenderSum()}
            </div>
        )
    }

}